import React from 'react';

type ProgressBarProps = {
    value: number;
    max: number;
    showLabel?: boolean;
    className?: string;
};

// Reusable progress bar. Renders nothing when max <= 0 (parity with legacy ng-show="EstimatedCount > 0").
const ProgressBar = ({ value, max, showLabel = true, className }: ProgressBarProps): JSX.Element | null => {
    if (!(max > 0)) {
        return null;
    }
    const pct = Math.min(100, Math.max(0, (value / max) * 100));
    return (
        <div className={`v2-progress-bar${className ? ` ${className}` : ''}`}>
            <div className="v2-progress-bar-track">
                <div
                    className="v2-progress-bar-fill"
                    style={{ width: `${pct}%` }}
                />
                <span className="v2-progress-bar-percent">{Math.round(pct)}%</span>
            </div>
            {showLabel ? (
                <span className="v2-progress-bar-label">
                    {value.toLocaleString()} / {max.toLocaleString()}
                </span>
            ) : null}
        </div>
    );
};

export default ProgressBar;
